import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAlDmTH0QZhijWoUC9gM1X_CzA_vr6qUBI",
  authDomain: "express-delivery-api.firebaseapp.com",
  databaseURL: "https://express-delivery-api-default-rtdb.firebaseio.com",
  projectId: "express-delivery-api",
  storageBucket: "express-delivery-api.firebasestorage.app",
  messagingSenderId: "1072551080464",
  appId: "1:1072551080464:web:15be730169d06c37409095",
  measurementId: "G-92ZTT648GC",
};

const app = initializeApp(firebaseConfig); // Initialize Firebase
const database = getDatabase(app); // Initialiser la Realtime Database

export { database };
